<div
  class="card card-custom"
  [ngClass]="{ 'card-body-progress card-body-progress-overlay': viewLoading }"
>
  <div class="card-header">
    <div class="card-title">
      <h3 class="card-title align-items-start flex-column">
        <span class="card-label font-weight-bolder text-dark">{{ data.title }}</span>
        <span class="text-muted mt-3 font-weight-bold font-size-sm" *ngIf="avatars[this.page]">{{
          avatars[this.page].date | date : 'MMM/dd/yyyy'
        }}</span>
      </h3>
    </div>
  </div>
  <div class="form">
    <div class="">
      <div class="d-flex justify-content-center" *ngIf="src | async as src">
        <img [src]="src" alt="" width="400px" height="400px" />
      </div>
      <div class="d-flex justify-content-between m-3">
        <button
          class="btn btn-light-success font-weight-bold mr-2"
          [disabled]="disabled"
          (click)="move(page + 1)"
        >
          Previous
        </button>
        <button
          class="btn btn-light-success font-weight-bold mr-2"
          [disabled]="disabled"
          (click)="move(page - 1)"
        >
          Next
        </button>
      </div>
    </div>
    <div class="card-footer">
      <div class="d-flex justify-content-between">
        <div class="mr-2"></div>
        <div>
          <button type="button" mat-raised-button (click)="onNoClick()">Cancel</button>&nbsp;
          <button
            type="button"
            mat-raised-button
            color="primary"
            mat-button
            (click)="onSaveClick()"
            color="primary"
            cdkFocusInitial
            [disabled]="viewLoading"
          >
            Save
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
